import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { filter, tap } from "rxjs/operators";
import { ApiBrowseAction } from "../../api-actions";
import { ApiPromiseState, ApiPromiseStateService } from "../../api-promise-state.service";
import { ApiSessionService } from "../../api-session.service";
import { ApiStateStoreService, ApiSubstate } from "../../api-state-store.service";
import { organizationId } from "../../apiParams/organization-id";
import { sessionId } from "../../apiParams/session-id";
import { OnsipApiResponse, extractData } from "../../apiResponse/response-body-new";
import { getApiActionName } from "../../onsip-api-action-new";
import { arrayToRecord } from "../../util/arrayToRecord";
import { ApiResourceService } from "../api-resource.service";
import {
  ApiMusicStreamSource,
  MusicStreamSource,
  apiMusicStreamSourceToMusicStreamSource as clean,
  MusicStreamSourceBrowseParams
} from "./music-stream-source";

const debug = false;

@Injectable({ providedIn: "root" })
export class MusicStreamSourceService extends ApiResourceService<MusicStreamSource> {
  constructor(
    session: ApiSessionService,
    store: ApiStateStoreService,
    promiseState: ApiPromiseStateService
  ) {
    super(session, store, promiseState, "MusicStreamSource", "url");
    debug && this.state.subscribe(state => console.warn("MusicStreamSource", state));
  }

  browseIfNoData(): Observable<ApiSubstate<MusicStreamSource>> {
    return this.state.pipe(
      tap(({ length }) => {
        if (!length) {
          this.musicStreamSourceBrowse();
        }
      }),
      filter(({ length }) => !!length)
    );
  }

  musicStreamSourceBrowse(
    params: MusicStreamSourceBrowseParams = {}
  ): ApiPromiseState<MusicStreamSource> {
    this.dispatcher.next({
      parameters: {
        Action: ApiBrowseAction.MusicStreamSourceBrowse,
        SessionId: this.store.state.pipe(sessionId()),
        OrganizationId: this.store.state.pipe(organizationId()),
        Limit: params.limit || 250,
        Url: params.url,
        Genre: params.genre,
        Type: "audio/mpeg"
      }
    });
    return this.promiseState.toPromise(ApiBrowseAction.MusicStreamSourceBrowse);
  }

  reducer(response: OnsipApiResponse): void {
    const action = getApiActionName(response);
    switch (action) {
      case ApiBrowseAction.MusicStreamSourceBrowse:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            extractData<Array<ApiMusicStreamSource>>(
              response,
              action,
              "MusicStreamSource",
              "MusicStreamSources"
            ).map(clean),
            this.indexKeyName
          ),
          action
        );
        break;
    }
  }
}
